export default {
  youtube: "0",
  twitch: "1",
};
